// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".site-reveal{position:fixed;top:0;right:0;bottom:0;left:0;display:flex;background-color:#fff;cursor:progress;z-index:7}.site-reveal-leave-active{opacity:0;cursor:pointer;transition:opacity .25s ease}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
